import { createSelector } from 'reselect'

const getState = state => state.transferwise

export const getCurrenciesList = createSelector(
  getState,
  ({ currencies }) => currencies
)
export const getRequirements = createSelector(
  getState,
  ({ requirements }) => requirements
)
export const getCountriesList = createSelector(
  getState,
  ({ countries }) => countries
)
export const getRecipient = createSelector(
  getState,
  ({ recipient }) => recipient
)
export const getIsRecipientCheckingNeededSelector = createSelector(
  getState,
  ({ isRecipientCheckingNeeded }) => isRecipientCheckingNeeded
)
